const getUserName = (user) => {
    if (!user)
        return '';
    return `${user?.firstname?.trim()} ${user?.lastname?.trim()}`;
};
export default getUserName;
